import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    activities: [],
    loading: false,
    pagination: {
      total_row: 1,
      last_page: 1,
    },
  }),
  getters: {
    activities(state) {
      return state.activities;
    },

    getOptionsOrg(state) {
      return state.optionsOrg;
    },
    loading(state) {
      return state.loading;
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    ngoActivities(state, payload) {
      state.activities = payload;
    },

    setLoading(state, val) {
      state.loading = val;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },

  actions: {
    async getSlids(context, payload) {
      context.commit("setLoading", true);
      if (payload.filter_date === null || payload.filter_date === "")
        payload.filter_date = "all";
      await api
        .get(ep.activities_endpoint, { params: payload })
        .then((res) => {
          context.commit("ngoActivities", res.data.data);
          context.commit("setPagination", res.data.pagination);
          context.commit("setLoading", false);
        })
        .catch((err) => {
          // context.commit("setLoading", false);
        });
    },
  },
};
